'use client'

import { Suspense } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { DEFAULT_BANNER_URL } from '@/constants/stackup'
import TextSearch from '@/components/TextSearch'
import BountyTabs from './ui/BountyTabs'
import BountyListingContainer from './ui/BountyListingContainer'

function BountyBanner() {
  return (
    <div className="relative h-auto lg:h-72">
      <Image
        src={DEFAULT_BANNER_URL}
        fill
        className="hidden lg:flex w-full h-auto"
        alt="Bug Bounties"
      />
      <div className="flex lg:hidden w-full h-48 bg-gray-900" />
      <div className="absolute inset-0 flex flex-col items-center lg:items-start justify-center p-8 lg:p-24 w-full lg:w-2/3">
        <h1 className="text-4xl lg:text-7xl font-semibold tracking-tight text-white leading-none mb-6">
          Bug Bounties
        </h1>
        <span className="font-normal lg:font-semibold text-center lg:text-left text-lg lg:text-xl text-white">
          Find and report security vulnerabilities. Earn rewards for keeping
          platforms safe.
        </span>
      </div>
    </div>
  )
}

export default function BugBountyPage() {
  return (
    <div className="pb-16">
      <BountyBanner />
      <div className="flex flex-col gap-6 px-8 sm:px-16 md:px-32 pt-10 pb-16 md:pt-16 md:pb-24">
        <div className="flex items-center justify-between w-full gap-3">
          <BountyTabs />
          <div className="flex items-center gap-3">
            <TextSearch placeholder="Find a Bug Bounty" />
          </div>
        </div>
        <Suspense>
          <BountyListingContainer />
        </Suspense>
      </div>
    </div>
  )
}
